'use client';

import { setupZeusInterceptors } from './setup';
import { useCommonAuthProvider } from 'app/_modules/auth/providers/CommonAuthProvider/CommonAuthProvider';

import React, { FC, useEffect, useRef } from 'react';

/**
 * Bridges the CommonAuthProvider context into the shared Zeus Axios client.
 *
 * Must be placed inside CommonAuthProvider in the component tree. Registers
 * axios interceptors exactly once (via the empty-deps effect) while keeping
 * auth functions always current through a ref updated on each render.
 */
export const ZeusClientSetupProvider: FC<React.PropsWithChildren> = ({ children }) => {
  const { getAccessToken, loginWithRedirect } = useCommonAuthProvider();

  const authRef = useRef({ getAccessToken, loginWithRedirect });

  // Keep ref current on every render so interceptors always call the latest auth functions.
  useEffect(() => {
    authRef.current = { getAccessToken, loginWithRedirect };
  }, [getAccessToken, loginWithRedirect]);

  // Register interceptors once. Auth ref stays current via the effect above.

  useEffect(() => setupZeusInterceptors(authRef), []);

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};
